import { api } from '../index';

const DASHBOARD_BASE_URL = 'api/teachers/me/dashboard';

async function getDashboardData(): Promise<DashboardResponse> {
  const result = await api.get<DashboardResponse>(DASHBOARD_BASE_URL);
  return result.data;
}

export default {
  getDashboardData,
};
